export default "__VITE_ASSET__8ac804c8__"